import { SearchableMunicipality } from 'types/Municipality'
import { ActionType, createReducer } from 'typesafe-actions'
import { mapActiveMunicipality, mapValuesUpdate } from 'components/map/actions'
import removeAccents from 'remove-accents-diacritics'

/**
 * Reducer for rent prices by municipality
 */
export const valuesByMunicipality = createReducer<
  Map<string, SearchableMunicipality>,
  ActionType<typeof mapValuesUpdate>
>(new Map()).handleAction(mapValuesUpdate, (state, { payload }) => {
  return new Map(
    payload.map(i => [
      i.GemeindeID,
      { ...i, normalisedName: removeAccents.remove(i.Gemeindename) }
    ])
  )
})

/**
 * The active municipality – in most cases whatever the user is currently
 * hovering over.
 */
export const activeMunicipality = createReducer<
  string,
  ActionType<typeof mapActiveMunicipality>
>('-1').handleAction(mapActiveMunicipality, (state, { payload }) => payload)
